import { render, staticRenderFns } from "./TermsText.vue?vue&type=template&id=32e5ef3f&scoped=true"
var script = {}
import style0 from "./TermsText.vue?vue&type=style&index=0&id=32e5ef3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e5ef3f",
  null
  
)

export default component.exports